import { getCurrencyByCode } from './localization'

const LOCALE_BY_CODE = {
  NGN: 'en-NG',
  USD: 'en-US',
  GBP: 'en-GB',
  AUD: 'en-AU',
  CAD: 'en-CA',
  EUR: 'de-DE',
  SGD: 'en-SG',
  ZAR: 'en-ZA',
  KES: 'en-KE',
  INR: 'en-IN',
  AED: 'ar-AE',
}

export function formatCurrency(value, currencyCode = 'NGN') {
  const cur = getCurrencyByCode(currencyCode)
  if (value == null || isNaN(Number(value))) return `${cur.symbol}0.00`
  const locale = LOCALE_BY_CODE[cur.code] || 'en-US'
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: cur.code,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
      .format(value)
      .replace(cur.code, cur.symbol)
  } catch {
    return `${cur.symbol}${Math.round(value).toLocaleString()}`
  }
}

// Back-compat: old callers that used formatNaira
export const formatNaira = (value) => formatCurrency(value, 'NGN')

export function formatDate(iso, dateFormat = 'DD/MM/YYYY') {
  if (!iso) return '—'
  const d = new Date(iso)
  if (isNaN(d.getTime())) return '—'
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const year = d.getFullYear()
  const monthShort = d.toLocaleDateString('en-GB', { month: 'short' })
  if (dateFormat === 'MM/DD/YYYY') return `${month}/${day}/${year}`
  return `${day} ${monthShort} ${year}`
}
